
declare var MeetHourJS: Object;

export default MeetHourJS;
